import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateColumnSpecCommand from "../ColumnConfigurations/Models/Commands/CreateColumnSpecCommand";
import UpdateColumnSpecCommand from "../ColumnConfigurations/Models/Commands/UpdateColumnSpecCommand";
import ColumnConfigurationLookup from "../ColumnConfigurations/Models/Lookups/ColumnConfigurationLookup";
import ColumnConfigurationSearchCriteria from "../ColumnConfigurations/Models/Queries/ColumnConfigurationSearchCriteria";

export interface IColumnSpecApiClient {
    getColumnSpecsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<ColumnConfigurationSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<ColumnConfigurationLookup>>>;
    addNewColumnSpec(command: Model.PlainObject<CreateColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateColumnSpec(command: Model.PlainObject<UpdateColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class ColumnSpecApiClient extends Data.ApiClientBase implements IColumnSpecApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticColumnSpec`)
    }

    public getColumnSpecsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<ColumnConfigurationSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<ColumnConfigurationLookup>>> {
        return this.axios.get(`${this.apiPath}/GetColumnSpecsPagedList?${Utils.getQueryString(payload)}`);
    }

    public addNewColumnSpec(command: Model.PlainObject<CreateColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewColumnSpec`, command);
    }

    public updateColumnSpec(command: Model.PlainObject<UpdateColumnSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateColumnSpec`, command);
    }
}